document.addEventListener("DOMContentLoaded", () => {

    const customer = JSON.parse(sessionStorage.getItem("protocolCustomer"));

    const protectedPages = [
        "/pages/dashboard",
        "/pages/provider-portal",
        "/pages/protocol",
        "/pages/orders"
    ];

    if (!protectedPages.includes(window.location.pathname)) return;

    if (
        !customer ||
        customer.wholesale !== true ||
        !customer.practiceId ||
        !customer.clinicId ||
        !customer.providerId
    ) {
        // window.location.href = "/account/login";
        window.location.href = "/";
    }

});